<template>
  <div class="textField" >
    <div class="fieldName">
      {{field}}: &nbsp;
    </div>
    <div>
       <div>
        <input
        v-model="search"
          @input="onChange"
            v-on:keyup.enter="onEnter"
          type="text"
        />
        </div>
        <div class="dropDown">
          <ul 
          v-show="isOpen && results.length>0"
            class="autocomplete-results"
          >
            <li
              v-for="(result, i) in results"
              :key="i"
              @click="setResult(result)"
              class="autocomplete-result"
            >
              {{result}}
              
            </li>
          </ul>
        </div>
       
      </div>
       <ValidIcon :valid="isValid" :label="error" style="margin-top:10px;font-size:16px;"></ValidIcon>
      <div v-show="(!results || results.length==0) && showAdd && search.length>0" class="btn" @click="doAdd(search)" >+</div>
       <div v-show="(!isValid) && allowOverride && search.length>0" class="btn" @click="override(search)" >x</div>
   
  </div>
</template>

<script>
import ValidIcon from '@/components/ValidIcon.vue';
import Validate from '@/mixins/validate.js'
export default {
    name: "textInput",
    mixins:[Validate],
    components:{ValidIcon},
    props: {
        items: {
            type: Array,
            required: false,
            default: () => [],
        },
        field: {
            type: String,
            required: false,
            default: () => "",
        },
        showAdd: {
            type: Boolean,
            required: false,
            default: () => false,
        },
        doAdd: {
            type: Function,
            required: false,
            default: () => null,
        },
        allowOverride: {
            type: Boolean,
            required: false,
            default: () => false,
        },
        validation: {
            type: Array,
            required: false,
            default: () => [],
        },

    },
    data() {
        return {
            search: "",
            results: [],
            isOpen: false,
            overriden:false,
           
        };
    },
    mounted() {
        document.addEventListener("click", this.handleClickOutside);
        this.results=this.items
        
    },
    destroyed() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    computed:{
      
    },
    methods: {
      onEnter: function() {
       this.isOpen=false
    },
        override(){
          this.overriden=true
          this.isOpen = false;
        },
        clearField(){
          this.search=""
          this.results=[]
          this.overriden=false
          
        },
        filterResults() {
        
          let result= this.items.filter(item => item.toLowerCase().indexOf(this.search.toLowerCase()) > -1);
          this.results = [...new Set(result)];
        },
        setResult(result) {
            this.search = result;
            this.isOpen = false;
        },
        onChange() {
            this.overriden=false
            this.filterResults();
            this.isOpen = true;
            this.updateVal()
        },
        handleClickOutside(event) {
            let self = this;
            if (!this.$el.contains(event.target)) {
                self.isOpen = false;
            }
        }
    },
    watch:{
     items(val){
  
      this.results=this.items
       
        this.filterResults()
     }
    }
   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/css/colors.scss";
  .textField{
    display:flex;
    margin:10px;
    flex-wrap: wrap;
  }
  input{
    color:inherit;
    font-size: inherit;
  }
  .btn{
    color:#fff;
    font-size: inherit;
  }
  
 .autocomplete {
    position: relative;
  }

  .autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 120px;
    min-height: 1em;
    max-height: 6em;    
    overflow: auto;
  }

  .autocomplete-result {
    background-color:#fffd;
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
  }

  .autocomplete-result:hover {
     background-color: $dropdown-selectBG;
    color: $dropdown-select;
  }
  .dropDown{
  position:absolute; 
  background-color: #fffd;
    width: 135px;
    margin-left: 5px;

  
  }
</style>
